import styled from "styled-components";
import { below } from "../../styles/Breakpoints";

export const StyledBurger = styled.button`
  position: fixed;
  top: 1rem;
  left: 1.25rem;
  top: clamp(0.75rem, calc(0.3rem + 1vw), 2rem);
  left: clamp(1%, calc(0.7rem + 1vw), 1.5rem);
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  ${below.tabletL`
    position: absolute;
  `}

  &:hover div {
    background: ${({ theme, open }) =>
      open ? theme.primaryLight : theme.primaryDark};
  }

  &:focus {
    outline: none;
  }

  div {
    width: 1.9rem;
    height: 0.25rem;
    margin-bottom: 6px;
    background: ${({ theme, open }) =>
      open ? theme.primaryDark : theme.primaryPop};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }

    :nth-child(2) {
      opacity: ${({ open }) => (open ? "0" : "1")};
      transform: ${({ open }) => (open ? "translateX(20px)" : "translateX(0)")};
    }

    :nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;
